export default "__VITE_ASSET__6200b7c9__"